export class AuthModel {
    constructor(
        public account: string,
        public dob: Date,
        public chipher?: string,
        //TODO delete later
        public estId?: string) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/models/auth.model.ts